import React from "react";
import { DialogStyle } from "../dialog/dialogBody/Dialog.styles";
import { Box, Checkbox } from "@mui/material";

const DealershipService = (args) => {
  const { services, handleService } = args;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", justifyContent: "space-between" }}>
        <Checkbox
          checked={services?.[0]?.is_active}
          onChange={(e) => handleService(services?.[0], e.target.checked)}
          disabled={true}
        />
        <span>Insurance Verification</span>
      </Box>
      <Box sx={{ width: "100%", justifyContent: "space-between" }}>
        <Checkbox
          checked={services?.[1]?.is_active}
          onChange={(e) => handleService(services?.[1], e.target.checked)}
          //   disabled={true}
        />
        <span>Knowledge Hub</span>
      </Box>
      <Box sx={{ width: "100%", justifyContent: "space-between" }}>
        <Checkbox
          checked={services?.[2]?.is_active}
          onChange={(e) => handleService(services?.[2], e.target.checked)}
          disabled={true}
        />
        <span>ID Verification</span>
      </Box>
      <Box sx={{ width: "100%", justifyContent: "space-between" }}>
        <Checkbox
          checked={services?.[3]?.is_active}
          onChange={(e) => handleService(services?.[3], e.target.checked)}
          disabled={true}
        />
        <span>PreQual</span>
      </Box>
    </Box>
  );
};

export default DealershipService;
